import { APIEvent } from '../events/apiEvent'
import { mapGetters } from 'vuex'
import * as Routes from '../constants/routes'
export default {
  data: function () {
    return {
      searchResults: [],
      currentPage: 1,
      perPage: 20,
      hasNextPage: false,
      requestData: null,
      startOffset: 0,
      pageNumber: 1,
      originalDynamicsValue: '',
      dynamicsHasChanges: false,
      ignoreInitialDynamicsChange: true,
      searchType: 'last_name',
      searchString: '',
      errorString: '',
      fields: {
        leakbotId: {
          label: 'LeakBot ID',
          sortable: false
        },
        deviceName: {
          label: 'Sigfox ID',
          sortable: false
        },
        first_name: {
          label: 'First name',
          sortable: false
        },
        last_name: {
          label: 'Surname',
          sortable: false
        },
        username: {
          label: 'Email',
          sortable: false
        }
      },
      searchLabels: {
        LeakBotId: 'LeakBot ID',
        DeviceName: 'Sigfox ID',
        first_name: 'First Name',
        last_name: 'Surname',
        post_code: 'Postcode',
        username: 'Username',
        serial_number: 'Serial Number'
      }
    }
  },
  computed: {
    ...mapGetters([
      'dynamics'
    ]),
    dynamicsValue: function () { // computed property will be updated when async call resolves
      return this.$store.state.dynamics
    }
  },
  mounted () {
    let param = {}
    if (this.$router.currentRoute.path === '/search:nondynamics') {
      param = { 'dynamics': 'no' }
    }
    if (this.$router.currentRoute.path === '/search:dynamics') {
      param = { 'dynamics': 'yes' }
    }
    if (this.$router.currentRoute.path === '/search' && this.dynamics === 'yes') {
      param = { 'dynamics': 'yes' }
    }
    if (this.$router.currentRoute.path === '/search' && this.dynamics === 'no') {
      param = { 'dynamics': 'no' }
    }
    if (this.$router.currentRoute.path === '/search:nondynamics' && window.localStorage.getItem('token') === null) {
      this.$router.push(Routes.LOGIN)
    }

    this.$store.dispatch(APIEvent.FETCH_TOKEN, param)
      .then((res) => {
        if (res.data.redirectURL !== undefined) {
          window.location = res.data.redirectURL
        }
      })
      .catch((error) => {
        // this.errLogin = error.message
        if (error.error === '0') {
          console.log(error)
          // this.$router.push(Routes.LOGIN)
          this.$store.dispatch(APIEvent.LOGOUT, {})
        }
        // console.log(error)
      })
  },

  methods: {
    fetchToken () {
      let param = {}
      if (this.dynamics === 'no' || this.$router.currentRoute.path === '/search:nondynamics') {
        param = { 'dynamics': 'no' }
      } else if (this.dynamics === 'yes') { param = { 'dynamics': 'yes' } }
      this.$store.dispatch(APIEvent.FETCH_TOKEN, param)
        .then((res) => {
          if (res.data.redirectURL !== undefined) {
            window.location = res.data.redirectURL
          }
        })
        .catch(this.handleError)
    },
    searchFunction (offset, data) {
      data = data || {}
      let startOffset = this.startOffset
      let fetchSize = this.fetch_size
      data.start_offset = startOffset
      data.fetch_size = fetchSize
      this.requestData = data
      let id = ''
      let searchString = this.searchString
      let searchType = this.searchType
      if (searchString.trim() === '') {
        this.errorString = 'Please enter search'
      } else {
        this.$store.dispatch('search', {searchType, searchString, startOffset, fetchSize})
          .then((results) => {
            if (results.length === 1) {
              id = results[0].leakbotId
              this.$router.push({name: 'DeviceView', params: { deviceID: id }})
            } else {
              this.pageNumber = (this.startOffset / this.perPage) + 1
              this.searchResults = results
            }
          })
          .catch(this.handleError)
      }
    },
    getSearchProp (propName) {
      let props = {
        startOffset: 'start_record'
      }
      let retValue = props[propName]
      return retValue || propName
    },
    sanitiseSearchData (options) {
      options.id = (typeof options.id !== 'undefined') ? options.id : ''
      let data = {}
      for (var prop in options) {
        if (typeof options[prop] !== 'undefined' && options[prop] !== '') {
          data[this.getSearchProp(prop)] = options[prop].toString()
        }
      }
    },
    page (event) {
      var next = event.currentTarget.className.indexOf('next') > -1
      if (next) {
        this.startOffset += this.perPage
        this.currentPage++
      } else {
        this.startOffset -= this.perPage
        this.currentPage--
      }
      this.searchFunction(this.startOffset, this.requestData)
    },
    handleError (error) {
      switch (error.error) {
        case 205:
          this.errorString = 'Please enter search'
          break

        case 507:
          this.errorString = 'You are not permitted to view the customer profile'
          break

        case 511:
          this.errorString = 'LeakBot ID has not been paired with a registered customer account'
          break

        case 305:
          this.errorString = 'No matches found'
          break

        case 209:
          // eslint-disable-next-line no-case-declarations
          let prop = this.searchLabels[this.searchType]
          this.errorString = prop + ' is not in the expected format'
          break

        default:
          this.errorString = 'No matches found'
          break
      }
    }
  }
}
